import type { Product } from 'src/components/restructure/product/types/product'
import { clientStore } from 'src/services/axiosInstance'

import type { BannerProductTab, BannerProductTabsProductsSlots } from './types'

function getTabProductIds(slots?: BannerProductTabsProductsSlots): string[] {
  return Object.values(slots ?? {})
    .map((id) => `${id ?? ''}`.trim())
    .filter(Boolean)
}

export async function fetchTabProducts(
  slots?: BannerProductTabsProductsSlots
): Promise<Product[]> {
  const ids = getTabProductIds(slots)

  if (!ids.length) {
    return []
  }

  const results = await Promise.all(
    ids.map((id) =>
      clientStore
        .get<Product>(
          `/v2/api/decathlon-pdp/product?productId=${encodeURIComponent(id)}`
        )
        .then((response) => response.data)
        .catch((error) => {
          console.error(`Erro ao buscar produto ${id}:`, error)

          return null
        })
    )
  )

  return results.filter(Boolean) as Product[]
}

export function getValidTabs(
  tabs: BannerProductTab[] = []
): BannerProductTab[] {
  const sanitized = tabs.filter((tab) => tab?.label?.trim())

  if (sanitized.length < 2) {
    return []
  }

  return sanitized.slice(0, 3)
}

export function getVisibleProducts(
  products: Product[],
  isBannerEnabled: boolean
): Product[] {
  const limited = products.slice(0, 4)

  if (isBannerEnabled && limited.length === 4) {
    return limited.slice(0, 3)
  }

  return limited
}
